import {ReactNode} from "react";

import {Types} from "@Common/types";

import {Static} from "./static";

export const Static2 = <T,>({getInitValue=undefined, next}:{
    getInitValue ?: () => T,
    next          : (arg:Types.Common.React.Static2.Static2Next<T>) => ReactNode,
}) => Static({
    getInitValue: () => {
        let value = getInitValue?.();
        return ({
            get: () => value,
            set: (v:T) => value = v,
        });
    },
    next,
});

